// extracted by mini-css-extract-plugin
module.exports = {"InfDownLoadModal":"InfDownLoadModal--ry3bU"};